import { ChangeDetectionStrategy, Component, ElementRef, inject, input, Renderer2, ViewChild } from '@angular/core';
import { IProductDataV3, IProductMediaItem } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { FindMediaByLabellPipe } from '@df/ui/common/find-media-by-label.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { NProductViewLayout, Product } from '../../../product.decorator';
import { ProductViewDimensionsAndDetailsComponent } from '../../product-view-dimensions-and-details.component';
import { PhotoswipeService } from '@df/ui/photoswipe/photoswipe.service';
import { DfEventService } from '@df/core/service/df-event';
import { DIALOG_EVENT, DialogEvent, DialogEventType } from 'projects/app-default/src/app/common/dialog/dialog.interface';
import { DOCUMENT } from '@angular/common';
import { App } from '@df/core/app';

export const DIMENSIONS_MODAL_RIGHT_ID = 'dimensionsAndDetailsModalRight';

@Component({
    selector: 'product-view-dimensions-and-details-modal-right',
    templateUrl: './product-view-dimensions-and-details-modal-right.html',
    styleUrls: ['./product-view-dimensions-and-details-modal-right.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FindMediaByLabellPipe, ImageModule, ProductViewDimensionsAndDetailsComponent]
})
export class ProductViewDimensionsAndDetailsModalRightComponent extends UiComponent {
    readonly content = input.required<NProductViewLayout.IBlockDataContent>();
    readonly product = input.required<Product<IProductDataV3>>();
    readonly photoswipeService = inject(PhotoswipeService);
    readonly dfEventService = inject(DfEventService);
    readonly document = inject(DOCUMENT);
    readonly renderer2 = inject(Renderer2);
    readonly app = inject(App);

    @ViewChild('image') image!: ElementRef;

    zoomIn() {
        if (this.app.isPlatformBrowser) {
            this.renderer2.addClass(this.document.body, 'photoswipe-loading');
        }
        const galleryUID = this.product().data?.id;
        const UID = this.getImage();
        const item = this.photoswipeService.getItems(galleryUID).find(item => item.uid?.includes(UID || ''));
        this.photoswipeService.fetchAll(galleryUID).then(() => {
            this.dfEventService.dispatch({
                id: DIALOG_EVENT,
                data: new DialogEvent(DialogEventType.Close, DIMENSIONS_MODAL_RIGHT_ID)
            });
            this.renderer2.removeClass(this.document.body, 'photoswipe-loading');
            this.photoswipeService.open(
                {
                    galleryUID,
                    index: item?.index ?? 0,
                    getThumbBoundsFn: () => {
                        const thumbnail = this.image.nativeElement; // find thumbnail
                        const pageYScroll = window.pageYOffset || this.document.documentElement.scrollTop;
                        const rect = thumbnail.getBoundingClientRect();

                        return {
                            x: rect.left,
                            y: rect.top + pageYScroll,
                            w: rect.width
                        };
                    }
                },
                item
            );
        });
    }

    getImage() {
        return this.product().data?.media?.find(m => m.labels?.includes('dimensions'))?.image;
    }
}
